const apiUrl = 'https://yestosuccessapi.azurewebsites.net/api';
const imageUrl = 'https://yestosuccessapi.azurewebsites.net';
const host = 'https://yestosuccess.azurewebsites.net';

// const apiUrl = 'https://yestosuccessdevapi.azurewebsites.net/api';
// const imageUrl = 'https://yestosuccessdevapi.azurewebsites.net';
// const host = 'https://yestosuccess.azurewebsites.net';

// const apiUrl = 'http://localhost:5000/api';
// const imageUrl = 'http://localhost:5000';
// const host = 'http://localhost:3000';
 
export { apiUrl, imageUrl, host };
 
// module.exports = { apiUrl,imageUrl,host}